import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useLocation } from "react-router-dom";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../Base/Services/ToastService";
import { getDatesProduccion } from "../../../../Base/Services/Moment/Luxon";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import Card from "../../../../Base/Components/Card/Card";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import Loader from "../../../../Base/Components/Loader/Loader";
import CalendarioOperativo from "../../../../Base/Components/Form/CalendarioOperativo";

// ------------------- CONSULTAS A LA API---------------------------
import { EliminarPase, EliminarPaseDetalle, getPasesSalidaDetPendienteRetorno, getPasesSalidaDetPorFecha, getPasesSalidaEncPendienteRetorno, getPasesSalidaEncPorFecha } from "../../../../API/Logistica/PasesSalidaRequest";


// ------------------ COMPONENTES DE NECESARIOS--------------------------
import ListadoPasesEnc from "./ListadoPasesEnc";
import ListadoPasesDet from "./ListadoPasesDet";
import PasesSalidaCRUD from "./CRUD/PasesSalidaCRUD";



const PasesSalidaScreen = ({Firma=null, PendienteRetorno=false}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);

  const [listadoEnc, setListadoEnc] = useState([]);
  const [listadoDet, setListadoDet] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [showDialog, setShowDialog] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedEnc, setSelectedEnc] = useState([]);
  const [selectedDet, setSelectedDet] = useState([]);
  const [habilitar, setHabilitar] = useState(true);
  const location = useLocation();
  const Referencia = location.state?.Referencia;

  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow( toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido." );
      return;
    }
    setLoading(true);
    const fechas = getDatesProduccion(dates);

    if(PendienteRetorno){
      const detallesTempo = await getPasesSalidaDetPendienteRetorno()
      setListadoDet(detallesTempo)
    }else{
      if(activeIndex === 0){
        const encabezadoTempo = await getPasesSalidaEncPorFecha(fechas)
        setListadoEnc(encabezadoTempo)
        setSelectedDet([])
      }else if(activeIndex === 1){
        const detallesTempo = await getPasesSalidaDetPorFecha(fechas)
        setListadoDet(detallesTempo)
        setSelectedEnc([])
      }
    }
    setLoading(false);
  };

  const ejecularEliminar = (selectedEnc) => {
    confirmDialog({
      message: selectedEnc.length > 1 ? "¿Estás seguro de eliminar los pases de salida?" : "¿Estás seguro de eliminar el pase de salida?",
      header: "Eliminar Pase de Salida",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      accept: () => {
        eliminarPase(selectedEnc)
      },
      rejectLabel: "No",
      reject: () => {}, 
      style: { backgroundColor: "white" },
    });
  };

  const eliminarPase = async (selectedEnc) =>{
    selectedEnc.forEach(async (select) => {
      if(select.IdEstado === 61 || select?.IdEstado === 62){
        toastShow( toast, "error", "Error al eliminar", select.IdEstado === 61 ? "El pase de salida ya esta completado" : 'El pase de salida está en "Pendiente Retorno" ' );
      }else{
        const respuesta = await EliminarPase(select)
      }
    })
    toastShow( toast, "success", "Eliminado", selectedEnc.length > 1 ? "Pases de salida eliminados correctamente" : 'Pase de salida eliminado correctamente' );
    getInfo()
    setSelectedEnc([])
  }

  const ejecularEliminarDet = (selectedDet) => {
    confirmDialog({
      message: selectedDet.length > 1 ? "¿Estás seguro de eliminar los detalle del pase?" : "¿Estás seguro de eliminar el detalle del pase?",
      header: "Eliminar Detalle",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      accept: () => {
        eliminarPaseDet(selectedDet)
      },
      rejectLabel: "No",
      reject: () => {},
      style: { backgroundColor: "white" },
    });
  };

  const eliminarPaseDet = async (selectedDet) =>{
    selectedDet.forEach(async (select) => {
      if(select.IdEstadoEnc === 61 || select?.IdEstadoEnc === 62){
        toastShow( toast, "error", "Error al eliminar", select.IdEstado === 61 ? "El pase de salida ya esta completado" : 'El pase de salida está en "Pendiente Retorno" ' );
      }else{
        const respuesta = await EliminarPaseDetalle(select)
      }
    })
    toastShow( toast, "success", "Eliminado", selectedDet.length > 1 ? "Detalles de pases de salida eliminados correctamente" : 'Detalle de pase de salida eliminado correctamente' );
    getInfo()
    setSelectedDet([])
  }

  useEffect(() => {
    if(PendienteRetorno){
      setActiveIndex(1)
    }else{
      if(Firma){
        setActiveIndex(0)
      }
    }
    getInfo();
    setTitlePage(getLabel(baseLang, "pasesDeSalida", config.language));
  }, [activeIndex, PendienteRetorno, Firma]);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h2>{getLabel(baseLang, "pasesDeSalida", config.language)}</h2>

            {!PendienteRetorno && (
              <CalendarioOperativo
                dates={dates}
                setDates={setDates}
                loading={loading}
                getInfo={getInfo}
              />
            )}

            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />

            {(!Firma && !PendienteRetorno) && (
              <Button
                icon="pi pi-plus"
                tooltip="Nueva"
                onClick={(e) => setShowDialog(true)}
              />
            )}

            {(!Firma && !PendienteRetorno) && (
              <Button
                icon="pi pi-times"
                type="button"
                className="p-button-danger listado__botones"
                tooltip="Eliminar"
                style={{ marginLeft: 1.5 }}
                disabled={activeIndex === 0 ? selectedEnc.length <= 0 : selectedDet <= 0}
                onClick={() => {
                  if(activeIndex === 0){
                    //ELIMINAR PASE COMPLETO
                    if(selectedEnc.length <= 0){
                      toastShow(toast,"warn","Advertencia","Seleccione al menos un pase de salida.");
                    }else{
                      ejecularEliminar(selectedEnc)
                    }

                  }else{
                    //ELIMINAR DETALLE
                    if(selectedDet.length <= 0){
                      toastShow(toast,"warn","Advertencia","Seleccione al menos un detalle de pase de salida.");
                    }else{
                      ejecularEliminarDet(selectedDet)
                    }
                  }
                }}
              />
            )}

          </div>
        }
        contenido={
          <div className="pt-4">
            <Loader loading={loading} />

            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >

              {!PendienteRetorno && (
                <TabPanel header="Listado">
                  <ListadoPasesEnc
                    listadoEnc ={listadoEnc}   
                    selectedEnc={selectedEnc} 
                    setSelectedEnc={setSelectedEnc}  
                    Firma={Firma}     
                    toast={toast}
                    getInfo={getInfo}  
                    setShowDialog={setShowDialog}  
                    Referencia={Referencia} 
                  />
                </TabPanel>
              )}

              {!Firma &&(
                <TabPanel header={PendienteRetorno ? 'Pendiente Retorno' : "Detalles"}>
                  <ListadoPasesDet
                    listadoDet ={listadoDet}   
                    selectedDet={selectedDet} 
                    setSelectedDet={setSelectedDet}            
                    setShowDialog={setShowDialog}   
                    setSelectedEnc={setSelectedEnc}  
                    PendienteRetorno={PendienteRetorno}
                    toast={toast}
                    getInfo={getInfo}  
                  />
                </TabPanel>
              )}
            </TabView>
          </div>
        }
      />

      <Dialog
        visible={showDialog}
        onHide={() => {
          setShowDialog(false)
          setSelectedEnc([])
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <PasesSalidaCRUD
          selectedEnc={selectedEnc}
          showDialog={showDialog}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
          getInfo={getInfo}
        />
      </Dialog>
    </div>
  );
};

export default PasesSalidaScreen;
